// extracted by mini-css-extract-plugin
module.exports = {"td":"TdComponent_td__1tXFq"};